RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    widgets.MetricSummaryTooltip = Marionette.CompositeView.extend({
        childView: App.views.SummaryItem.extend({
            tagName: 'li'
        }),
        childViewContainer: 'ul',
        className: 'metric-summary',

        getTemplate: function () {
            const me = this;
            if (me.collection) {
                if (me.collection.length > 1) {
                    return '#widgetInsightsSummaryTooltipTemplate';
                }
                if (me.collection.length === 1 && (RivalIQ.enums.widgetTypes[me.collection.models[0].get('key')] === RivalIQ.enums.widgetTypes.SOCIAL_POSTS)) {
                    return '#widgetInsightsSummaryTooltipFocusCompanyTemplate';
                }
            }

            return '#widgetInsightsSingleMetricTooltipTemplate';
        },

        ui: {
            icon: '.fa'
        },

        behaviors: {
            Titles: RivalIQ.behaviors.Titles
        },

        serializeData: function () {
            const me = this;

            if (me.model) {
                me.metric = me.model;
            } else if (me.collection.length === 1) {
                if (RivalIQ.enums.widgetTypes[me.collection.models[0].get('key')] !== RivalIQ.enums.widgetTypes.SOCIAL_POSTS) {

                    me.metric = me.collection.first();
                }
            }

            return {
                metric: me.metric
            };
        },

        templateHelpers: function () {
            const me = this;

            return App.utils.getSummaryTemplateHelpers(me, me.metric);
        },

        onRender: function () {
            const me = this;

            const metric = me.model || me.collection.first();
            const color = metric.getColor();
            if (color) {
                me.ui.icon.css('color', color);
            }

            me.$('[data-toggle="popover"]').popover();
        },

        _renderChildren: function () {
            const me = this;

            if (!me.model && me.collection.length === 1) {
                if (RivalIQ.enums.widgetTypes[me.collection.models[0].get('key')] !== RivalIQ.enums.widgetTypes.SOCIAL_POSTS) {
                    return;
                }
            }

            return Marionette.CompositeView.prototype._renderChildren.apply(me, arguments);
        },

        attachHtml: function (collectionView, childView) {
            // NOTE we render stacked bars in reverse order, so we need to
            // reflect that in the labels by reversing them here
            collectionView._bufferedChildren.unshift(childView);
        }
    });

    const Trend = widgets.TrendView = Marionette.ItemView.extend({
        className: 'small text-muted',

        template: '#widgetMetricSummaryTrendTemplate',

        serializeData: function () {
            const me = this;

            const model = me.model.clone({
                normalized: me.model.isNormalizable()
            });

            return {
                isNormalized: model.isNormalized(),
                value: model.getDeltaRel({
                    format: false
                })
            };
        },

        templateHelpers: function () {
            return {
                formatter: RivalIQ.formatter.relativePercent
            };
        }
    });

    widgets.MetricSummaryView = RivalIQ.views.LayoutView.mixin({
        regions: {
            'submetrics': '.x-submetrics',
            'sparkline': '.x-sparkline-region',
            'trend': '.x-trend'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        behaviors: function () {
            const me = this;

            const information = me.dashboardModel.metric.getInformation();

            if (information) {
                return {
                    Information: {
                        information: information,
                        behaviorClass: RivalIQ.behaviors.Information
                    }
                };
            }

            // NOTE if we don't have information then display titles
            return {
                Titles: {
                    behaviorClass: RivalIQ.behaviors.Titles
                }
            };
        },

        getTemplate: function () {
            const me = this;

            if (me.getProp('inline')) {

                if (me.getProp('sparkline')) {
                    return '#widgetMetricSummaryInlineSparklineTemplate';
                }

                return '#widgetMetricSummaryInlineTemplate';
            }

            return '#widgetMetricSummaryTemplate';
        },

        loadData: function () {
            const me = this;

            const metricDefinition = me.dashboardModel.metric;
            _.extend(metricDefinition.attributes, {
                format: me.dashboardModel.format,
                alternate: me.getProp('alternate')
            });

            let dimensions;

            if (me.getProp('dimension')) {
                dimensions = metricDefinition.getDimension(me.getProp('dimension')).getMetrics();
            } else {
                dimensions = me.dashboardModel.metrics;
            }

            const attrs = {
                dimension: me.getProp('dimension')
            };
            return RivalIQ.collections.MetricDefinitions.fetch(attrs, [metricDefinition, dimensions])
                .done(function (metrics) {
                    me.model = metrics[0];
                    me.collection = metrics[1];

                    const limit = me.getProp('dimensionLimit');

                    if (_.exists(limit)) {
                        me.collection.reset(me.collection.filterValues({
                            limit: limit
                        }));
                    }
                });
        },

        className: function () {
            const me = this;

            const classNames = ['metric-summary'];

            if (me.getProp('inline')) {
                classNames.push('metric-summary-inline');
            }

            return classNames.join(' ');
        },

        templateHelpers: function () {
            const me = this;

            const breakdownHeader = me.getProp('breakdown_header');

            return _.extend(App.utils.getSummaryTemplateHelpers(me, me.model), {
                'breakdownHeader': breakdownHeader
            });
        },

        buildSummaryItemsView: function (collection) {

            const me = this;

            let submetricsClassName = _.compact([
                'list-unstyled',
                'metric-legend',
                (me.getProp('legend') ? 'list-legend' : null)
            ]).join(' ');

            if (collection.length === 4) {
                submetricsClassName += ' four-submetrics';
            }

            if (collection.length === 2) {
                submetricsClassName += ' two-submetrics';
            }

            let View = App.views.SummaryItems;
            const group = me.getProp('group');
            let config = {
                className: submetricsClassName
            };

            if (group) {

                config = {
                    group: group,
                    groupClassName: submetricsClassName
                };

                View = App.views.GroupedSummaryItems;
            }

            return new View(_.extend({
                collection: collection
            }, config));
        },

        onRender: function () {
            const me = this;

            if (me.collection) {
                me.submetrics.show(me.buildSummaryItemsView(me.collection));
            }

            if (me.getProp('sparkline')) {
                me.showSparkline();
            }

            if (me.hasTrend()) {
                me.showTrend();
            }

            me.$('[data-toggle="popover"]').popover();
        },

        showSparkline: function () {
            const me = this;

            me.sparkline.showWidget({
                widgetId: RivalIQ.enums.widgetTypes.METRIC_SPARKLINE_CHART,
                options: {
                    concept: me.dashboardModel.metric,
                    dimension: me.getProp('dimension')
                }
            });
        },

        showTrend: function () {
            const me = this;
            const view = new Trend({
                model: me.model
            });
            me.trend.show(view);
        },

        hasTrend: function () {
            const me = this;
            return Boolean(me.getProp('trend'));
        }
    });

    widgets.RankView = Marionette.ItemView.extend({
        className: 'small text-muted',

        template: '#widgetMetricSummaryRankTemplate',

        serializeData: function () {
            const me = this;
            const metricData = me.model.dataValues;

            // NOTE this implementation assumes that larger values are
            // superior to smaller values, which will need to change if we
            // add a metric for which smaller values are superior.
            // NOTE there is a risk that the rank calculated here will be
            // different than that of observationServices because it is
            // calculated differently
            const sortedLandscapeMetricData = _.sortBy(metricData.landscape, function (companyMetricData) {

                // return the negative of the value since we want the result to be in descending order
                return -companyMetricData.value;
            });

            return {
                total: _.size(metricData.landscape),
                rank: sortedLandscapeMetricData.indexOf(metricData.company) + 1
            };
        }
    });

    const MetricSummaryWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                inline: false,
                legend: false
            });

            props = widgets.Chart.buildMetrics(me, props);

            return props;
        },

        view: widgets.MetricSummaryView
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_SUMMARY, MetricSummaryWidget);
});
